import { fetchStudies } from 'api/study';
import { Study } from 'interfaces/study';
import queryClient from 'utils/queryClient';
import { QueryOptions, useQueryWithErrorAndRetrySnackbar } from 'utils/useQueryWithErrorAndRetrySnackbar';

export const useStudies = (
  labId: string,
  withStatistics: boolean = false,
  queryOptions: QueryOptions<Study[]> = {}
) => {
  const queryKeyWithoutStatistics = ['studies', labId];
  const queryKeyWithStatistics = ['studies', labId, 'withStatistics'];
  const queryKey = withStatistics ? queryKeyWithStatistics : queryKeyWithoutStatistics;

  return useQueryWithErrorAndRetrySnackbar(
    queryKey,
    async () => {
      // Check if a query with "withStatistics" is already running
      const isWithStatisticsQueryRunning = queryClient.getQueryState(queryKeyWithStatistics)?.status === 'loading';

      // If "withStatistics" is false but a "withStatistics" query is running, wait for it to complete
      if (!withStatistics && isWithStatisticsQueryRunning) {
        const data = await queryClient.fetchQuery(queryKeyWithStatistics, () => fetchStudies(labId, true));
        return data;
      }

      const data = await fetchStudies(labId, withStatistics);

      if (withStatistics) {
        // Save the results to the cache without the "withStatistics" flag
        queryClient.setQueryData(queryKeyWithoutStatistics, data);
      }

      return data;
    },
    queryOptions
  );
};
